export default __webpack_public_path__ + "static/media/vk.f98e33b4.svg";